import "core-js/stable";
import "raf/polyfill";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./i18n/index.js";
import App from "./App";

const root = createRoot(document.querySelector("#root"));

root.render(<App />);
